// extracted by css-extract-rspack-plugin
export default {"component":"JsonFileUpload-module__component___Li8si","selectOnClick":"JsonFileUpload-module__selectOnClick___kCBNk","input":"JsonFileUpload-module__input___RSJT_"};